<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading [loading]="isLoading"></ef-loading>
<!-- <ef-loading-container [observables]="[authorizations$, payrollItems$, serviceItems$]"></ef-loading-container> -->
<ef-user-authorization
    [activeReports]="activeReports$ | async"
    [activeServiceItems]="activeServiceItems$ | async"
    [activeTasks]="activeTasks$ | async"
    [authClasses]="authClassesSelectItems$ | async"
    [classItemsFilterSelectItems]="classItemsFilterSelectItems$ | async"
    [items]="authorizations$ | async"
    [AuthAutomatedPI]="AuthAutomatedPI$ | async"
    [useClass]="useClass$ | async"
    [directReports]="directReports$ | async"
    [activeReports]="activeReports$ | async"
    [directReportsFilterSelectItems]="directReportsFilterSelectItems$ | async"
    [payrollItems]="payrollItems$ | async"
    [payrollItemsFilterSelectItems]="payrollItemsFilterSelectItems$ | async"
    [pendingAuthorizations]="pendingAuthorizations$ | async"
    [pendingAuthsCount]="pendingAuthsCount$ | async"
    [selectedError]="selectedError$ | async"
    [serviceItems]="serviceItemsSelectItems$ | async"
    [serviceItemsFilterSelectItems]="serviceItemsFilterSelectItems$ | async"
    [tasks]="tasksSelectItems$ | async"
    [tasksFilterSelectItems]="tasksFilterSelectItems$ | async"
    [userAuthTypes]="userAuthTypesSelectItems$ | async"
    [userGroups]="userGroups$ | async"
    [yearOptions]="yearOptions$ | async"
    [modifiedDatesSelectItems]="modifiedDatesSelectItems$ | async"
    [employeeswithoutauths]="employeeswithoutauths$ | async"
    (AddModeChanged)="OnAddModeChanged($event)"
    (AddPending)="OnAddPending($event)"
    (AuthorizationChanged)="OnAuthorizationChanged($event)"
    (Copy)="OnCopy($event)"
    (DateFilterChanged)="OnDateFilterChanged($event)"
    (Delete)="OnDelete($event)"
    (Save)="OnSave($event)"
    (SaveError)="OnSaveError($event)"
    (ShowError)="OnShowError($event)"
>
</ef-user-authorization>
